import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SafeUrlPipe } from '../../../pipes/safe-url.pipe';
import Player from '@vimeo/player';
import { ReadService } from 'src/app/services/read.service';

@Component({
  selector: 'app-use-us-header-video',
  templateUrl: './use-us-header-video.component.html',
  styleUrls: ['./use-us-header-video.component.css'],
})
export class UseUsHeaderVideoComponent implements OnInit, AfterViewInit {
  player: any;
  // player = new Player.player();
  videoId = 607578035;
  videoPlayer: HTMLElement;
  targets: NodeListOf<HTMLImageElement>;
  videoOptions: { id: number; responsive: boolean };
  useUsVideoId: any;
  constructor(private readService: ReadService) {}

  ngOnInit(): void {

  }

  intersectionFn() {
    this.targets = document.querySelectorAll('.videoWrapper');
    //  console.log('Targets',  this.targets);

    const lazyLoad = (target) => {
      const io = new IntersectionObserver((entries, observer) => {
        // console.log('Entries', entries);
        // console.log('Observer', observer);
        entries.forEach((entry) => {
          // console.log('😍');
          if (entry.isIntersecting) {
            //   console.log('intersecting', entry);
            this.player = new Player('vidIframe', this.videoOptions);

            this.player.play();
            // const img = entry.target;
            // const src = img.getAttribute('data-lazy');
            // img.setAttribute('src', src);
            // img.classList.add('fade');
            // observer.disconnect();
          } else {
            this.player.pause();
          }
        });
      });
      io.observe(target);
    };
    this.targets.forEach(lazyLoad);
  }

  ngAfterViewInit(){
    this.useUsVideoId = this.readService.returnObservableOrderByFn(
      'cscBranchDirectory/corporate/homepageVideo',
      'videoId',
      'asc'
    );
    this.useUsVideoId.subscribe((d) => {
      //  console.log('VIDEO ID', d);
      const [v] = d;
      // console.log('V', v.videoId);
      this.videoOptions = {
        id: v.videoId,
        responsive: true,
      };
      this.player = new Player('vidIframe', this.videoOptions);
      this.player.play();
      // this.player.setMuted(true);
    });

    // this.player.getDuration().then(function(duration) {
    //   console.log('VIMEO duration', duration);
    // });

    // this.player.on('finish', function(data) {
    //   console.log('VIMEO finish', data);
    // });
    // this.player.on('timeupdate', function(data) {
    //   this.videoPlayer = document.getElementById('vidIframe');
    //   if(data.seconds > 57){
    //     document.getElementById("homepageLeaderComponent").scrollIntoView({behavior: "smooth"});
    //   }
    // });

    // document.getElementById('vidIframe').addEventListener('ended', function (event) {
    //   console.log('VIMEO EVENT', event);
    // });

    // this.player.getEnded().then(function(ended) {
    //   console.log('VIMEO ENDED', ended);    }).catch(function(error) {
    //     console.log('VIMEO ERROR', error);
    // });
    setTimeout(() => {
      this.intersectionFn();
    }, 3000);
  }
}
